import { IProps } from '@/Interfaces/Icons/Props.interface';

const GoogleIcon = (props: IProps) => {
  return (
    <svg fill='currentColor' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
      <path d='M12 10.9v2.95h4.2c-.17 1.1-1.26 3.22-4.2 3.22a4.68 4.68 0 0 1 0-9.36c1.43 0 2.39.62 2.94 1.15l2-1.93A7.3 7.3 0 0 0 12 4.9a7.48 7.48 0 1 0 0 14.96c4.32 0 7.18-3.04 7.18-7.32 0-.49-.05-.87-.12-1.24H12z' />
    </svg>
  );
};

export default GoogleIcon;
